__turbopack_context__.v({
  "Checkbox": "CheckboxField-module-scss-module___u_YSW__Checkbox",
  "SingleCheckbox": "CheckboxField-module-scss-module___u_YSW__SingleCheckbox",
});
